<h2 mat-dialog-title>Restore Config</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <div class="details">
    <div class="config-header row">
      <h5>SSL Restore Config</h5>
      <button
        class="button"
        [cdkCopyToClipboard]="data.config | json"
        (cdkCopyToClipboardCopied)="onCopied($event)"
      >
        <fa-icon [icon]="['far', 'copy']" size="lg"></fa-icon>
      </button>
    </div>

    <pre class="config">{{ data.config | json }}</pre>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()">
    <fa-icon [icon]="['fas', 'download']" size="lg"></fa-icon>
    Download
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
